import axios from 'axios'

export const logoutUser = () => {
  return axios.get('/api/v1/logout')
}
